import { Barcode, Create, Edit, List, ListDemo, RemovedStockItem, BarcodeSingle } from "../Components/index.js";

export default [
    {
        path: "/canteen/inventory/item",
        component: List,
        name: "inventory.item",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/item-demo",
        component: ListDemo,
        name: "inventory.item-demo",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/item-removed",
        component: RemovedStockItem,
        name: "inventory.item.removed",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/barcode/show",
        component: Barcode,
        name: "inventory.barcode",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/barcode-show/:id",
        component: BarcodeSingle,
        name: "inventory.barcode.show",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/item/create",
        component: Create,
        name: "inventory.item.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/multi-item/create",
        component: () => import("../Components/MultiCreate.vue"),
        name: "inventory.multi.item.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/item/:id/edit",
        component: Edit,
        name: "inventory.item.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
